<template>
  <div>
    <v-alert
      :class="classes.expansion"
      @click="expansion ? (hidden = !hidden) : null"
      :type="error ? 'error' : null"
      :outlined="error"
    >
      <div class="d-flex gap-5 align-center justify-space-between">
        <div class="d-flex align-center gap-5">
          <v-avatar v-if="image" :size="imageSize" color="white">
            <v-img :src="apiDomain + '/min/' + image" contain />
          </v-avatar>
          <h2
            class="fw500"
            :class="{
              f32: !expansion,
              f24: expansion,
              'error--text': error,
              'white--text': darkExpansion,
            }"
          >
            <slot name="title">
              {{ title }}
            </slot>
          </h2>
          <slot name="titleRight" />
        </div>
        <div class="d-flex gap-5 align-center">
          <slot name="title-active" />
          <svg
            v-if="expansion"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            preserveAspectRatio="xMidYMid meet"
            viewBox="1 1 10 10"
            :class="{
              'icon-rotate': !hidden,
              'error--text': error,
              'primary--text': !darkExpansion,
              'white--text': darkExpansion,
            }"
          >
            <path
              fill="currentColor"
              d="M7.854 5.854a.5.5 0 1 0-.708-.708L6 6.293L4.854 5.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l1.5-1.5ZM11 6A5 5 0 1 0 1 6a5 5 0 0 0 10 0ZM6 2a4 4 0 1 1 0 8a4 4 0 0 1 0-8Z"
            />
          </svg>
        </div>
      </div>
    </v-alert>
    <div :class="classes.body">
      <slot />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BaseSection',
  props: {
    title: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: null,
    },
    imageSize: {
      type: [Number, String],
      default: 96,
    },
    classBody: {
      type: String,
      default: 'd-grid gap-5',
    },
    error: Boolean,
    expansion: Boolean,
    darkExpansion: Boolean,
    classExpansion: {
      type: String,
      default: '',
    },
    hiddenData: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(['apiDomain']),
    classes() {
      let result = {
        body: {
          'expansion-hidden': this.expansion && this.hidden,
          'expansion-visible pa-2 pt-3': this.expansion && !this.hidden && !this.darkExpansion,
        },
        expansion: {
          white: this.expansion && !this.darkExpansion,
          primary: this.expansion && this.darkExpansion,
          'mb-0 pa-4 pointer rounded-0': this.expansion,
          'transparent mb-10 pa-0': !this.expansion,
        },
      }
      result.body[this.classBody] = !!this.classBody
      result.expansion[this.classExpansion] = !!this.classExpansion
      return result
    },
  },
  data: () => ({
    hidden: null,
  }),
  mounted() {
    this.hidden = this.hiddenData
  },
}
</script>

<style scoped lang="scss">
@import 'src/scss/colors';
.v-avatar {
  border: 1px solid var(--v-secondary-lighten1) !important;
}
.expansion {
  &-hidden {
    width: 0 !important;
    height: 0 !important;
    overflow: hidden;
  }
  &-visible {
    border: 1px solid white;
  }
}

svg {
  transition-duration: 0.3s;

  &.icon-rotate {
    transition-duration: 0.3s;
    transform: rotateZ(-180deg);
    transform-origin: center;
  }
}
</style>
